import React, { useEffect, useState } from 'react';
import SystemMonitor from './system-monitor';
import { trackEvent } from './analytics';

// Componente para mostrar información del navegador de forma discreta
const BrowserInfo: React.FC = () => {
  const [browserInfo, setBrowserInfo] = useState({
    name: '',
    version: '',
    os: ''
  });

  useEffect(() => {
    // Detectar el navegador y su versión
    const userAgent = navigator.userAgent;
    let browserName = 'Desconocido';
    let browserVersion = '';
    let osName = 'Desconocido';

    // Detectar el sistema operativo
    if (userAgent.indexOf('Windows') !== -1) osName = 'Windows';
    else if (userAgent.indexOf('Mac') !== -1) osName = 'macOS';
    else if (userAgent.indexOf('Linux') !== -1) osName = 'Linux';
    else if (userAgent.indexOf('Android') !== -1) osName = 'Android';
    else if (userAgent.indexOf('iOS') !== -1) osName = 'iOS';

    // Detectar el navegador y versión
    if (userAgent.indexOf('Firefox') !== -1) {
      browserName = 'Firefox';
      browserVersion = userAgent.match(/Firefox\/([0-9.]+)/)?.[1] || '';
    } else if (userAgent.indexOf('Edg') !== -1) {
      browserName = 'Edge';
      browserVersion = userAgent.match(/Edg\/([0-9.]+)/)?.[1] || '';
    } else if (userAgent.indexOf('Chrome') !== -1) {
      browserName = 'Chrome';
      browserVersion = userAgent.match(/Chrome\/([0-9.]+)/)?.[1] || '';
    } else if (userAgent.indexOf('Safari') !== -1) {
      browserName = 'Safari';
      browserVersion = userAgent.match(/Version\/([0-9.]+)/)?.[1] || '';
    } else if (userAgent.indexOf('OPR') !== -1 || userAgent.indexOf('Opera') !== -1) {
      browserName = 'Opera';
      browserVersion = userAgent.match(/(?:OPR|Opera)\/([0-9.]+)/)?.[1] || '';
    }

    setBrowserInfo({
      name: browserName,
      version: browserVersion,
      os: osName
    });
  }, []);

  return (
    <div className="text-gray-400 text-xs absolute bottom-1 right-2 opacity-70 select-none">
      {browserInfo.name} {browserInfo.version} | {browserInfo.os}
    </div>
  );
};

function App() {
  useEffect(() => {
    // Track page load
    trackEvent('page_view', { page: 'main' });
  }, []);

  return (
    <div className="min-h-screen bg-gray-900 p-4 relative">
      <SystemMonitor />
      <BrowserInfo />
    </div>
  );
}

export default App;